import posthog from "posthog-js";
import { config } from "@/config/env";

const enabled = !!config.posthogToken;

export type AnalyticsEvent =
  | "search_started"
  | "alternative_dates_viewed"
  | "alternative_dates_selected"
  | "accommodation_selected"
  | "extras_submitted"
  | "details_submitted"
  | "checkout_submitted"
  | "checkout_failed"
  | "booking_completed";

export const analytics = {
  setAid(aid: string | null) {
    if (!enabled) return;
    if (aid) {
      posthog.register({ aid });
    } else {
      posthog.unregister("aid");
    }
  },

  setCampground(slug: string) {
    if (!enabled) return;
    posthog.register({ campground: slug });
  },

  page(path: string) {
    if (!enabled) return;
    posthog.capture("$pageview", { $current_url: path });
  },

  capture(event: AnalyticsEvent, properties?: Record<string, unknown>) {
    if (!enabled) return;
    posthog.capture(event, properties);
  },
};
